import { useApp } from "@/App";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export default function Footer({ onAdminClick }) {
  const { selectedLocation, locations, setSelectedLocation } = useApp();
  const currentLoc = locations.find(l => l.slug === selectedLocation);
  const locationName = selectedLocation === "cestlice" ? "Čestlice" : "Butovice";

  return (
    <footer className="bg-[#050505] border-t border-white/5 py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-black tracking-tighter uppercase mb-4">
              CAR <span className="text-[#39FF14]">SPA</span>
            </h3>
            <p className="text-sm text-zinc-500 leading-relaxed mb-6">
              Profesionální ruční mytí a detailing. Péče o váš vůz
              s důrazem na kvalitu a detail.
            </p>
            <button
              onClick={() => setSelectedLocation(null)}
              className="text-xs text-[#39FF14] font-bold uppercase tracking-wider hover:text-white transition-colors duration-300"
              data-testid="footer-switch-location"
            >
              Změnit pobočku →
            </button>
          </div>

          {/* Contact */}
          <div>
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#39FF14] mb-6">
              Kontakt — {locationName}
            </p>
            <div className="space-y-4">
              {currentLoc && (
                <>
                  <div className="flex items-start gap-3">
                    <MapPin className="w-4 h-4 text-zinc-500 mt-0.5" />
                    <span className="text-sm text-zinc-400">{currentLoc.address}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Phone className="w-4 h-4 text-zinc-500" />
                    <a href={`tel:${currentLoc.phone}`} className="text-sm text-zinc-400 hover:text-[#39FF14] transition-colors duration-300">
                      {currentLoc.phone}
                    </a>
                  </div>
                  <div className="flex items-center gap-3">
                    <Mail className="w-4 h-4 text-zinc-500" />
                    <a href={`mailto:${currentLoc.email}`} className="text-sm text-zinc-400 hover:text-[#39FF14] transition-colors duration-300">
                      {currentLoc.email}
                    </a>
                  </div>
                  <div className="flex items-start gap-3">
                    <Clock className="w-4 h-4 text-zinc-500 mt-0.5" />
                    <span className="text-sm text-zinc-400">{currentLoc.hours}</span>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#39FF14] mb-6">
              Rychlé odkazy
            </p>
            <div className="space-y-3">
              {[
                { label: "Služby", href: "#services" },
                { label: "Ceník", href: "#pricing" },
                { label: "Rezervace", href: "#booking" },
                { label: "O nás", href: "#about" },
              ].map((link) => (
                <button
                  key={link.href}
                  onClick={() => {
                    const el = document.querySelector(link.href);
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="block text-sm text-zinc-500 hover:text-white transition-colors duration-300 uppercase tracking-wider"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 pb-16 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">
            &copy; {new Date().getFullYear()} Car Spa. Všechna práva vyhrazena.
          </p>
          <button
            className="text-xs text-zinc-700 cursor-pointer hover:text-zinc-500 transition-colors py-4 px-6"
            onClick={onAdminClick}
            data-testid="admin-trigger"
          >
            Premium Auto Detailing
          </button>
        </div>
      </div>
    </footer>
  );
}
